// @flow
import moment from 'moment'
import cloneDatetime from './cloneDatetime'

// Utils
const TIMEZONE_FREE_FORMAT = 'YYYY-MM-DD HH:mm'

/**
 * Function that clones given value with respect to the timezone but then
 * remove the timezone part ramaining the time unchanged.
 *
 * For example, this function will convert `2019-02-03T18:33:00-08:00` to
 * `2019-02-03T18:33:00+05:00` (where +05:00 timezone is a timezone
 * in the user's browser).
 *
 * This function is usefuls when you need to compare date and time of two
 * moments regardless the timezone. Unfortunatelly, moment doesn't have that
 * ability built in.
 * @param  {string|moment} val
 * @return {moment}
 */
const cloneDatetimeWithoutTimezone = (val: ?string | moment): moment => {
  const parsedDatetime = cloneDatetime(val)
  const strWithoutTimezone = parsedDatetime.format(TIMEZONE_FREE_FORMAT)
  return moment(strWithoutTimezone, TIMEZONE_FREE_FORMAT)
}

export default cloneDatetimeWithoutTimezone
